// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1gU1t","label":"Completed_label__1IwqQ"};